const IconFacebook = () => {
  return (
    <path
      d="M13.3333 9.33333V7.74583C13.3333 7.02917 13.4917 6.66667 14.6042 6.66667H16V4H13.6708C10.8167 4 9.875 5.30833 9.875 7.55417V9.33333H8V12H9.875V20H13.3333V12H15.6833L16 9.33333H13.3333Z"
      fill="currentColor"
      data-testid="icon-facebook"
    />
  );
};

export default IconFacebook;
